import React, { SVGProps } from "react";

export default function SupStopwatch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 4H12V3H8V4Z" fill="currentColor" />
      <path d="M10.5 7V10H9.5V7H10.5Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11C16 14.3137 13.3137 17 10 17C6.68629 17 4 14.3137 4 11C4 7.68629 6.68629 5 10 5C11.424 5 12.7321 5.49606 13.761 6.3248L14.6464 5.43934L15.3535 6.14645L14.4853 7.01468C15.4276 8.07442 16 9.47037 16 11ZM15 11C15 13.7614 12.7614 16 10 16C7.23858 16 5 13.7614 5 11C5 8.23858 7.23858 6 10 6C12.7614 6 15 8.23858 15 11Z"
        fill="currentColor"
      />
    </svg>
  );
}
